import * as BusEvents from "@/constants/bus-events";

export default {
    created() {
        Bus.$on(BusEvents.CART_UPDATED, this.onCartUpdated);
    },
    beforeDestroy() {
        Bus.$off(BusEvents.CART_UPDATED, this.onCartUpdated);
    },
    methods: {
        onCartUpdated() {
            // implement on component
        },
    },
};
